import { api } from "constants/RotasAPI";
import usePost from "hooks/usePost";
import toast from "react-hot-toast";
import { queryClient } from "shared/util/queryClient";

export const useRestaurarDespesaGroupPay = (despesaId: number) => {
  const onSuccess = () => {
    queryClient.invalidateQueries(["despesas-paginadas-group-pay"]);
    toast.success("Despesa restaurada com sucesso!");
  };
  const onError = () => {
    toast.error("Erro ao restaurar a despesa!");
  };

  return usePost<number>({
    url: api.groupPay.restaurarDespesaGroupPay,
    onSuccess,
    onError,
    pathVariables: despesaId.toString(),
  })
}